import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgRichMoisturizerGlyph from './svgs/RichMoisturizerGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var richMoisturizerGlyph = (props => useIcon(SvgRichMoisturizerGlyph, SvgRichMoisturizerGlyph, props));

export { richMoisturizerGlyph as default };
